var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"30%"}},[_vm._v("\n\t\t\tPatient\n\t\t")]),_c('th',{staticStyle:{"width":"70%"}},[_vm._v("\n\t\t\tEvents\n\t\t")])])])
}]

export { render, staticRenderFns }